export default "__VITE_ASSET__048ecbce__"